/* src/app/layouts/login_layout.component.css */
h1 {
  text-align: center;
}
/*# sourceMappingURL=login_layout.component.css.map */
